// extracted by mini-css-extract-plugin
export default {"productSwitcher":"ProductSwitcher_productSwitcher__-VVNh","tabs":"ProductSwitcher_tabs__1b-dK","tab":"ProductSwitcher_tab__Fj-aV"};